export enum XpressDocumentTypeEnum {
	None = 0,
	MayorsPermit = 1,
	DTIRegistration = 2,
	DOTAccreditation = 3,
	SECRegistration = 4,
	BusinessPermit = 5,
	BIRCertificate = 6,
	LGUAccreditation = 7,
	Insurance = 8,
	TourOperatorAccreditation = 9,
	DriverLicense = 10,
	OfficialReceiptAndCertificateOfRegistration = 11,
	NBIClearance = 12,
	VehiclePhoto = 13,
	FitToDriveCertificate = 14,
	PreviousAppExperience = 15,
	PaOrCpc = 16,
	AuthorizationLetter = 17,
	NotarizedSPA = 18,
	DeedOfSale = 19,
	CertificateOfSale = 20,
	DriverLicenseProfessional = 21,
	DriverLicenseNonProfessional = 22,
	Pa = 23,
	Cpc = 24,
	AlOrNotarizedSPA = 25,
	DeedOfSaleOrCertificateOfSale = 26,
	MedicalExamResults = 27,
	SssNumberProof = 28,
	TinNumberProof = 29,
	PagIbigNumberProof = 30,
	PhilHealthNumberProof = 31,
	PoliceClearance = 32,
}

